<template>
  <Card
    v-if="isValid"
    v-bind="cardData"
    class="iphone-cashback"
  >
    Sparen Sie bis zu 100&nbsp;€
    <Modal
      heading-text="iPhone und der Telekom Handyankauf"
      close-on-backdrop
    >
      <template #trigger="{ open }">
        <LinkButton
          tag="button"
          type="button"
          no-styling
          class="btn btn--footnote"
          @click="open"
        >
          *
        </LinkButton>
      </template>

      <template #default>
        <p>
          <strong
            >Ankaufsbonus für Apple iPhone 15, Apple iPhone 16, Apple iPhone 16 Pro, Apple iPhone 16
            Pro Max, Apple iPhone 16 Plus und iPhone 16e</strong
          >
        </p>
        <div class="unstyled-html">
          <ul>
            <li>
              Der Ankaufsbonus gilt für private Endkunden ab 18 Jahren bei Kauf eines der im
              folgenden genannten Smartphone Modelle vom 01.04.-30.06.2025 bei der Telekom
              Deutschland GmbH (TDG) und bei zusätzlichem Verkauf eines teilnahmeberechtigten Apple
              iPhone Modells (iPhone XS, iPhone XS Max, iPhone XR, iPhone SE 2. Generation (ab April
              2020) / 3. Generation (ab März 2022), iPhone 11, iPhone 11 Pro, iPhone 11 Pro Max,
              iPhone 12, iPhone&nbsp; 12 mini, iPhone 12 Pro, iPhone 12 Pro Max, iPhone 13, iPhone
              13 mini, iPhone 13 Pro, iPhone 13 Pro Max, iPhone 14, iPhone 14 Plus, iPhone 14 Pro,
              iPhone 14 Pro Max, iPhone 15, iPhone 15 Plus, iPhone 15 Pro, iPhone 15 Pro Max, iPhone
              16, iPhone 16 Plus, iPhone 16 Pro, iPhone 16 Pro Max, iPhone 16e)&nbsp; an die
              Assurant Deutschland GmbH.
            </li>
            <li>
              Das Handyankaufsangebot für das Altgerät muss bis zum 30.06.2025 generiert werden und
              das Altgerät bis zum 21.07.2025. bei der Assurant Deutschland GmbH bzw. ihrem
              Dienstleister angekommen sein.&nbsp;
            </li>
            <li>
              Teilnehmer erhalten ein Ankaufsangebot für das Altgerät, zzgl. eines Ankaufsbonus. 100
              € Ankaufsbonus gibt es beim Kauf eines Apple iPhone 15, Apple iPhone 16, Apple iPhone
              16 Pro, Apple iPhone 16 Pro Max, Apple iPhone 16 Plus oder iPhone 16e.
            </li>
            <li>
              Das Altgerät muss funktionsfähig sein, d.h. es muss ein- und ausschaltbar sowie
              entsperrt (kein SIM-/Net-Lock) sein, darf keinen Wasserschaden oder Displaybruch
              aufweisen und muss einen Mindestankaufswert von 1 € haben.
            </li>
            <li>Teilnahme mit max. 3 Aktionsgeräten pro Haushalt. Solange der Vorrat reicht.</li>
            <li>
              Ausrichter der Aktion ist Telekom Deutschland GmbH, Landgrabenweg 151, 53227 Bonn,
              Deutschland.
            </li>
            <li>
              Hier finden Sie die vollständigen
              <a
                target="_blank"
                href="https://www.telekom.de/pdf/teilnahmebedingungen-fuer-den-ankaufsbonus-fuer-apple-iphone-16-serie"
                >Teilnahmebedingungen</a
              >.
            </li>
          </ul>
        </div>
      </template>
    </Modal>
    beim Kauf eines iPhone Modells, wenn Sie Ihr altes Gerät in Zahlung geben.
    <br />
    <strong>Aktionszeitraum:</strong> 01.04.2025 - 30.06.2025

    <template #action>
      <Modal
        heading-text="iPhone und der Telekom Handyankauf"
        close-on-backdrop
      >
        <template #trigger="{ open }">
          <LinkButton
            tag="button"
            type="button"
            transparent
            @click="open"
          >
            So funktioniert der Handyankauf
          </LinkButton>
        </template>
        <template #default>
          <p><strong>So funktioniert's</strong></p>
          <div class="unstyled-html">
            <ul>
              <li>
                Einfach im Kaufprozess des Neugerätes, oder später unter
                <a
                  target="_blank"
                  href="https://www.telekom.de/unterwegs/smartphones-und-tablets/handy-verkaufen"
                  >Handy verkaufen</a
                >
                Ihr altes teilnahmeberechtigtes Smartphone zum Ankauf anbieten. Wichtig: Um einen
                Ankaufsbonus zu bekommen, erstellen Sie Ihr Ankaufsangebot innerhalb des
                Aktionszeitraums der Bonusaktion. Alle Aktionszeiträume finden Sie im Folgenden,
                jeweiligen, Rechtstext.
              </li>
              <li>Sie beantworten nur 4 einfache Fragen.</li>
              <li>
                Wenn Sie ihr Handy später verkaufen, benötigen Sie die Geräte-IMEI Ihres neuen
                Smartphones. Diese muss auf
                <a
                  target="_blank"
                  href="https://www.telekom.de/unterwegs/smartphones-und-tablets/handy-verkaufen"
                  >Handy verkaufen</a
                >
                im Schritt 5 "Ankaufsbonus" angegeben werden, um den Ankaufsbonus zu erhalten.
              </li>
              <li>
                Wichtig: Um einen Ankaufsbonus zu bekommen, muss das Altgerät bis spätestens zum
                letzten Tag des Versandzeitraums bei Assurant oder dessen Dienstleister eingegangen
                sein. Alle Versandzeiträume finden Sie im Folgenden, jeweiligen, Rechtstext.
              </li>
              <li>Assurant löscht alle Ihre persönlichen Daten mit zertifizierter Software.</li>
              <li>
                Wenn Ihr Gerät funktioniert und normale Gebrauchsspuren hat, erhalten Sie den besten
                Preis.
              </li>
              <li>
                Bei Angebotsannahme erfolgt die Auszahlung des Ankaufspreises zusammen mit dem
                Ankaufbonus durch eine Banküberweisung.
              </li>
            </ul>
          </div>
        </template>
      </Modal>
    </template>
  </Card>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { Card, LinkButton, Modal } from '@i22-td-smarthome/component-library';
import type { CardComponentProps } from '@i22-td-smarthome/component-library/dist/components/card/card.vue';

const props = defineProps({
  articleNumber: { type: String, default: undefined },
});

const cardData: CardComponentProps = {
  heading: {
    tag: 'h3',
    size: 'xl',
    text: 'iPhone und der Telekom Handyankauf',
    spacesBottomRem: true,
  },
  imagePositionXs: 'bottom',
  imagePosition: 'right',
  imageBackground: {
    src: '/content/content-images/iphone-promotion/9adaba061f48d8dbe8d761a87e67a36d/iphone-cashback-s.webp',
    srcMd:
      '/content/content-images/iphone-promotion/a3d59424eb5861345021ecea88864293/iphone-cashback-m.webp',
    lazy: true,
    sizes: 'xs:100vw sm:100vw md:100vw lg:1446px',
    alt: '',
  },
};
const isValid = computed(() =>
  [
    '99934506',
    '99934512',
    '99934497',
    '99934503',
    '99934516',
    '99934518',
    '99934522',
    '99934508',
    '99934520',
    '99934499',
    '99934524',
    '99934509',
    '99934514',
    '99934504',
    '99934500',
    '99935720',
    '99936261',
    '99935666',
    '99935663',
    '99935645',
    '99935740',
    '99935737',
    '99935748',
    '99935704',
    '99935712',
    '99935758',
    '99935699',
    '99935710',
    '99935756',
    '99935661',
    '99935754',
    '99935651',
    '99935640',
    '99935746',
    '99935722',
    '99935718',
    '99935632',
    '99935701',
    '99935734',
    '99935653',
    '99935724',
    '99935671',
    '99935647',
    '99935728',
    '99935707',
    '99935752',
    '99935657',
    '99935637',
    '99935630',
    '99935634',
    '99935750',
    '99935649',
    '99935643',
    '99935655',
    '99935659',
    '99935743',
    '99935716',
    '99936263',
    '99935726',
    '99935676',
    '99935696',
    '99935684',
    '99935732',
    '99935730',
    '99935674',
    '99935678',
    '99935688',
    '99935694',
    '99935714',
    '99935690',
    '99935669',
    '99935692',
    '99935686',
    '99935702',
    '99935667',
    '99935682',
    '99936265',
    '99936254',
    '99936274',
    '99936252',
    '99936259',
    '99935680',
    '99935641',
    '99935741',
    '99935697',
    '99935635',
    '99936279',
    '99935664',
    '99935738',
  ].includes(props.articleNumber)
);
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.iphone-cashback {
  margin-bottom: 2rem;
  border: 1px solid #a3a3a3;
  --card-image-background-object-position: bottom center;
  --card-bg-color: transparent;

  @include mq($mq-sm) {
    --card-image-background-object-position: center right;
  }
}
</style>
